// Whether AI Studio shows its timeline, per browser. It starts open; a
// collapse is remembered. Storage can be missing or throw (private mode,
// blocked site data): every failure keeps the timeline open.

export const STUDIO_TIMELINE_COLLAPSED_KEY = 'autoclipper:ai-studio:timeline-collapsed';

type ReadableStorage = Pick<Storage, 'getItem'> | null | undefined;
type WritableStorage = Pick<Storage, 'setItem' | 'removeItem'> | null | undefined;

export function readStudioTimelineOpen(storage: ReadableStorage): boolean {
  try {
    return storage?.getItem(STUDIO_TIMELINE_COLLAPSED_KEY) !== '1';
  } catch {
    return true;
  }
}

export function writeStudioTimelineOpen(storage: WritableStorage, open: boolean): void {
  try {
    if (open) storage?.removeItem(STUDIO_TIMELINE_COLLAPSED_KEY);
    else storage?.setItem(STUDIO_TIMELINE_COLLAPSED_KEY, '1');
  } catch {
    // Remembering the choice is a convenience; ignore storage failures.
  }
}
